import React from 'react';
import { View, Text } from 'react-native';

export function BuscarScreen() {
  return (
    <View>
      <Text>Em Breve!</Text>
    </View>
  );
}
